import styled from 'styled-components'
import { Flex, Box } from 'rebass'

export const FlexWrapper = styled(Flex)`
  position: relative;
`

export const SummaryBox = styled(Box)`
  position: relative;
  z-index: 1;
  a {
    color: ${(props) => props.theme.colors.white};
    font-weight: bold;
  }
`

export const SummaryColumn = styled(Box)`
  color: white;
  line-height: 1.5;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${(props) => props.background.x1});
  background-color: ${(props) => props.theme.colors.blue};

  @media only screen and (-webkit-min-device-pixel-ratio: 1.3),
    only screen and (min-resolution: 144dpi),
    only screen and (min-resolution: 1.5dppx) : {
    background-image: url('${(props) => props.background.x2}');
  }
  ul {
    margin-left: 20px;
  }
  ul > li {
    margin-bottom: 0;
  }
`

export const FormColumn = styled(Box)`
  background-color: ${(props) => props.theme.colors.blue_light};
`
